import React from 'react';
import { Theme } from '@material-ui/core';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';

import { colorPalette } from '../styles/customStyling';

const styles = (theme: Theme) => ({
  mainContainer: {
    fontWeight: 300,
    color: colorPalette.white,
    backgroundColor: colorPalette.blueExtraDark,
    position: 'absolute' as 'absolute',
    top: 75,
    left: 0,
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    textAlign: 'center' as 'center',
    minHeight: 400,
    width: '100%',
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(15)
  },
  orangeDot: {
    color: colorPalette.slOrange
  },
  firstParagraph: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    fontSize: 32,
    [theme.breakpoints.down('xs')]: {
      fontSize: 20
    }
  },
  secondParagraph: {
    maxWidth: 720,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    fontSize: 18,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16
    }
  }
});

// Start typescript definitions
interface OwnProps extends WithStyles<typeof styles> {}
// End typescript definitions

export const ReviewApplicationHeader = (props: OwnProps) => (
  <div className={props.classes.mainContainer}>
    <p className={props.classes.firstParagraph}>
      Review and submit your application
      <span className={props.classes.orangeDot}>.</span>
    </p>
    <p className={props.classes.secondParagraph}>
      Please review all of your responses, and verify that the information you entered is correct.
      You will not be able to make updates to this application once it has been submitted.
    </p>
  </div>
);

export default withStyles(styles)(ReviewApplicationHeader);
